import { ResourceHelperService } from './../resource-helper.service';
export class UsageEventProductMappingsService {
  public resource: InterACT.Interfaces.IResource<InterACT.Interfaces.UsageEventProductMappings.UsageEventProductMappingsResponse>;

  constructor($resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.resource = $resource('api/usage-event-product-mappings');
  }

  /**
   * A method that retrieves a given page of iitems
   * @param page the page number to retrieve
   * @param perPageCount the amount of items to retrieve per page
   * @param searchText the query/search to use to filter your items
   */
  public getList(page?: number, perPageCount?: number, searchText?: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, searchText);

    return this.resource.get(options).$promise.then((resource) => {
      return resource;
    });
  }
}